// apps/web/src/lib/vendas/numero.ts — Fase 12, CR-D1-01 / WR-D1-08 (D1).
// Leitura ÚNICA de número digitado nas telas de Vendas (quantidade, preço, reajuste, fechamento, rascunho fiscal).
// Usa o mesmo parser pt-BR estrito da API (`interpretarNumeroPtBr`, @pieltec/contracts): "." só é milhar em grupos válidos,
// "," é o decimal e o que é AMBÍGUO ("1.500": 1,5 ou 1500?) é recusado com mensagem de campo em vez de adivinhado.
import { interpretarNumeroPtBr, mensagemNumeroAmbiguo } from '@pieltec/contracts';

/**
 * Número digitado em pt-BR. NaN quando vazio, inválido ("abc", "1e3", "0x10", "1,2,3") ou ambíguo ("1.500").
 * Sempre finito quando devolve número.
 */
export function lerNumeroDigitado(texto: string): number {
  const resultado = interpretarNumeroPtBr(texto);
  return resultado.tipo === 'ok' ? resultado.valor : Number.NaN;
}

/**
 * Mensagem de campo para um texto que não virou número: a explicação da ambiguidade quando for o caso
 * (o usuário precisa saber que "1.500" não foi aceito e por quê), senão a `mensagemPadrao` da tela.
 */
export function mensagemNumeroDigitado(texto: string, mensagemPadrao: string): string {
  const resultado = interpretarNumeroPtBr(texto);
  if (resultado.tipo === 'ambiguo') return mensagemNumeroAmbiguo(texto, resultado);
  return mensagemPadrao;
}

/** True quando o texto tem conteúdo mas não é um número aceito (inválido ou ambíguo). */
export function numeroDigitadoRecusado(texto: string): boolean {
  const resultado = interpretarNumeroPtBr(texto);
  return resultado.tipo === 'invalido' || resultado.tipo === 'ambiguo';
}

const FORMATO_CAMPO = new Intl.NumberFormat('pt-BR', { useGrouping: false, minimumFractionDigits: 0, maximumFractionDigits: 6 });

/** Valor numérico como texto de campo editável (vírgula decimal, sem milhar, sem notação científica): "1234,5". */
export function paraTexto(valor: number): string {
  return FORMATO_CAMPO.format(valor);
}

const FORMATO_CAMPO_PRECO = new Intl.NumberFormat('pt-BR', { useGrouping: false, minimumFractionDigits: 2, maximumFractionDigits: 6 });

/** Preço como texto de campo editável, sempre com ao menos 2 casas ("5,00"), como no formulário de criação. */
export function paraTextoPreco(valor: number): string {
  return FORMATO_CAMPO_PRECO.format(valor);
}
